import React from 'react';
import { motion } from 'motion/react';
import { Check } from 'lucide-react';
import Button from './Button';
import { useTilt } from '../../hooks/useTilt';
import type { PricingPlan } from '../../types';

interface PricingCardProps {
  plan: PricingPlan;
  index: number;
}

export default function PricingCard({ plan, index }: PricingCardProps) {
  const { rotateX, rotateY, handleMouseMove, handleMouseLeave } = useTilt({ strength: 4 });

  return (
    <motion.div
      className={`relative rounded-2xl overflow-visible card-shimmer card-shimmer-light card-glow card-glow-light h-full ${
        plan.popular
          ? 'bg-white ring-2 ring-primary shadow-2xl z-10'
          : 'bg-white border border-gray-200 shadow-lg'
      }`}
      variants={{
        hidden: { opacity: 0, y: 40 },
        visible: {
          opacity: 1,
          y: 0,
          transition: { duration: 0.5, delay: index * 0.15 },
        },
      }}
      onMouseMove={handleMouseMove}
      onMouseLeave={handleMouseLeave}
      style={{ rotateX, rotateY, transformPerspective: 1000 }}
    >
      {plan.popular && (
        <div className="absolute -top-4 left-1/2 -translate-x-1/2 px-4 py-1 bg-primary text-white text-sm font-bold rounded-full whitespace-nowrap z-20">
          Plus populaire
        </div>
      )}
      <div className="p-4 sm:p-6 overflow-hidden rounded-2xl">
      <h3 className="text-text-dark font-bold text-xl mb-2">{plan.name}</h3>
      <p className="text-text-gray text-sm mb-4">{plan.description}</p>
      <div className="mb-4">
        <span className="text-3xl font-extrabold text-text-dark">{plan.price}</span>
        {plan.period && (
          <span className="text-text-gray text-sm ml-1">{plan.period}</span>
        )}
      </div>
      <ul className="space-y-2 mb-5">
        {plan.features.map((feature, i) => (
          <li key={i} className="flex items-center gap-3 text-sm text-text-dark">
            <Check className="w-4 h-4 text-success flex-shrink-0" />
            {feature}
          </li>
        ))}
      </ul>
      <Button
        variant={plan.popular ? 'primary' : 'secondary'}
        href="https://xamxamshop.com"
        className={`w-full ${!plan.popular ? 'text-text-dark border-gray-300 hover:bg-gray-50' : ''}`}
      >
        {plan.cta}
      </Button>
      </div>
    </motion.div>
  );
}
